export const getSanitizedJsonAndParse = (targetId, fallbackJson = {}) => {
  const targetElement = document.getElementById(targetId);

  if (!targetElement || !targetElement.textContent) {
    return fallbackJson;
  }

  return JSON.parse(targetElement.textContent);
};
